module.exports = __webpack_public_path__ + "static/media/image_placeholder_file_long.63e85488.jpg";